export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11184.2c4f4359.jpg";